import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CBP_FORM_REFERENCE_DATA } from '../../../constants';
import axios from 'axios';
const STOP_REGION = process.env.REACT_APP_STOP_REGION

export const getCbpFormReferenceData = createAsyncThunk(
  'stop/getCbpFormReferenceData',
  async (params) => {
    const config = {
      headers: {
        Authorization: params,
        Region: STOP_REGION
      },
    };
    const response = await axios
      .get(CBP_FORM_REFERENCE_DATA, config)
      .then((response) => {
        return response;
      })
      .catch((e) => {
        console.log(e);
        return e;
      });
    const data = await response.data.data;
    return data === undefined ? null : data;
  }
);

const cbpFormReferenceSlice = createSlice({
  name: 'stop/cbpFormReference',
  initialState: null,
  reducers: {
    resetCbpFormReference: () => null,
  },
  extraReducers: {
    [getCbpFormReferenceData.fulfilled]: (state, action) => action.payload,
  },
});

export const { resetCbpFormReference } = cbpFormReferenceSlice.actions;

export default cbpFormReferenceSlice.reducer;
